import { defineQuery } from 'next-sanity'
import { imageFields } from '../atoms'

export const careersFeatureBlockFields = `
  _id,
  _type,
  heading,
  decorativeShapeLeft,
  decorativeShapeRight,
  backgroundImage {
    ${imageFields}
  },
  svgImage {
    ${imageFields}
  },
  svgSize,
  svgContent
`

export const CAREERS_FEATURE_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-feature-block"][0]{
    ${careersFeatureBlockFields}
  }
`)
